import { elementScroll as f, observeElementOffset as s, observeElementRect as d, Virtualizer as p } from "./index546.js";
import { defaultKeyExtractor as S, defaultRangeExtractor as V, measureElement as b } from "./index546.js";
import { computed as g, unref as l, shallowRef as E, watch as o, triggerRef as i, onScopeDispose as v } from "vue";
function w(e) {
  const t = new p(l(e)), a = E(t), u = t._didMount();
  return o(
    () => l(e).getScrollElement(),
    (r) => {
      r && t._willUpdate();
    },
    {
      immediate: !0
    }
  ), o(
    () => l(e),
    (r) => {
      t.setOptions({
        ...r,
        onChange: (c, m) => {
          var n;
          i(a), (n = r.onChange) == null || n.call(r, c, m);
        }
      }), t._willUpdate(), i(a);
    },
    {
      immediate: !0
    }
  ), v(u), a;
}
function z(e) {
  return w(
    g(() => ({
      observeElementRect: d,
      observeElementOffset: s,
      scrollToFn: f,
      ...l(e)
    }))
  );
}
export {
  p as Virtualizer,
  S as defaultKeyExtractor,
  V as defaultRangeExtractor,
  f as elementScroll,
  b as measureElement,
  s as observeElementOffset,
  d as observeElementRect,
  z as useVirtualizer
};
